module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-mini-sm-f9b01b749061f8f7f49862ec68e49c03.png";